import { getConfig } from "./config";

export const ENVIRONMENT = getConfig().environmentName;
export const SCRIBENOTE_GRAPHQL = getConfig().graphql;
export const SCRIBENOTE_FLASK = getConfig().flask;
export const SCRIBENOTE_WS = getConfig().ws;
export const SCRIBENOTE_WEB = getConfig().web;

// Stripe config
export const UNLIMITED_PRICE_ID_MONTHLY =
  getConfig().stripe.unlimited_price_id_monthly;
export const COMPANION_SNACK_PACK_PRICE_ID =
  getConfig().stripe.companion_snack_pack_price_id;
export const COMPANION_SMALL_PRICE_ID_MONTHLY =
  getConfig().stripe.companion_small_price_id_monthly;
export const COMPANION_LARGE_PRICE_ID_MONTHLY =
  getConfig().stripe.companion_large_price_id_monthly;

// Intercom config
function getCookie(name) {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="))
    ?.split("=")[1];
}

const intercomDisabled =
  getCookie("intercom_disabled") === "true" ||
  document.location.pathname.startsWith("/pip");

export const INTERCOM_ENABLED = intercomDisabled
  ? false
  : getConfig().intercom.intercom_enabled;
export const INTERCOM_ID = getConfig().intercom.intercom_id;

export const NORMAL_ON_EXAM = "Normal on exam";
export const BAR = "BAR, stable on exam";
export const SEARCH_DEBOUNCE_TIME = 600;
export const NOTE_SEARCH_PLACEHOLDER =
  "Search by title or content...";

export const OBJECTIVE_FIELDS = [
  {
    name: "temperature",
    label: "Temperature",
    type: "vital",
  },
  {
    name: "heartRate",
    label: "Heart Rate",
    type: "vital",
  },
  {
    name: "respiratoryRate",
    label: "Respiratory Rate",
    type: "vital",
  },
  {
    name: "capillaryRefillTime",
    label: "Capillary Refill Time",
    type: "vital",
  },
  {
    name: "bodyConditionScore",
    label: "Body Condition Score",
    type: "vital",
  },

  // ----------------- SYSTEMS --------------------

  {
    name: "eyes",
    label: "Eyes",
    type: "system",
  },
  {
    name: "ears",
    label: "Ears",
    type: "system",
  },
  {
    name: "oral",
    label: "Oral",
    type: "system",
  },
  {
    name: "cardiovascular",
    label: "Cardiovascular",
    type: "system",
  },
  {
    name: "respiratory",
    label: "Respiratory",
    type: "system",
  },
  {
    name: "neurological",
    label: "Neurological",
    type: "system",
  },
  {
    name: "musculoskeletal",
    label: "Musculoskeletal",
    type: "system",
  },
  {
    name: "lymphatic",
    label: "Lymphatic",
    type: "system",
  },
  {
    name: "gastrointestinal",
    label: "Gastrointestinal",
    type: "system",
  },
  {
    name: "reproductiveAndUrinary",
    label: "Reproductive & Urinary",
    type: "system",
  },
  {
    name: "coatAndSkin",
    label: "Coat & Skin",
    type: "system",
  },
  {
    name: "overall",
    label: "Overall",
    type: "overall",
  },
];

export const APPOINTMENT_OBJECTIVE_NORMAL_DEFAULTS = [
  {
    name: "temperature",
    label: "Temperature",
  },
  {
    name: "heartRate",
    label: "Heart Rate",
  },
  {
    name: "weight",
    label: "Weight",
  },
  {
    name: "respiratoryRate",
    label: "Respiratory Rate",
  },
  {
    name: "capillaryRefillTime",
    label: "Capillary Refill Time",
  },
  {
    name: "mucousMembranes",
    label: "Mucous Membranes",
  },
  {
    name: "hydrationStatus",
    label: "Hydration Status",
  },
  {
    name: "bodyConditionScore",
    label: "Body Condition Score",
  },
  {
    name: "painScore",
    label: "Pain Score",
  },
  {
    name: "fearAnxietyStressScore",
    label: "Fear Anxiety Stress Score",
  },
  {
    name: "eyes",
    label: "Eyes",
  },
  {
    name: "ears",
    label: "Ears",
  },
  {
    name: "nasal",
    label: "Nasal",
  },
  {
    name: "oralDental",
    label: "Oral",
  },
  {
    name: "cardiovascular",
    label: "Cardiovascular",
  },
  {
    name: "respiratory",
    label: "Respiratory",
  },
  {
    name: "neurological",
    label: "Neurological",
  },
  {
    name: "musculoskeletal",
    label: "Musculoskeletal",
  },
  {
    name: "lymphatic",
    label: "Lymphatic",
  },
  {
    name: "gastrointestinal",
    label: "Gastrointestinal",
  },
  {
    name: "reproductiveUrinary",
    label: "Reproductive & Urinary",
  },
  {
    name: "furSkin",
    label: "Integument",
  },
  {
    name: "masses",
    label: "Masses",
  },
];

export const TEMPLATE_COLOR_SCHEMES = {
  rose: {
    backgroundColor: "bg-rose-200 dark:bg-gray-600/20",
    headerColor: "bg-rose-400",
  },
  orange: {
    backgroundColor: "bg-orange-200 dark:bg-gray-600/20",
    headerColor: "bg-orange-400",
  },
  yellow: {
    backgroundColor: "bg-yellow-200 dark:bg-gray-600/20",
    headerColor: "bg-yellow-400",
  },
  lime: {
    backgroundColor: "bg-lime-200 dark:bg-gray-600/20",
    headerColor: "bg-lime-400",
  },
  teal: {
    backgroundColor: "bg-teal-200 dark:bg-gray-600/20",
    headerColor: "bg-teal-400",
  },
  cyan: {
    backgroundColor: "bg-cyan-200 dark:bg-gray-600/20",
    headerColor: "bg-cyan-400",
  },
  blue: {
    backgroundColor: "bg-blue-200 dark:bg-gray-600/20",
    headerColor: "bg-blue-400",
  },
  purple: {
    backgroundColor: "bg-purple-200 dark:bg-gray-600/20",
    headerColor: "bg-purple-400",
  },
};

export const isTestEnv = getConfig().isTestEnv;

export const isScribenoteEmail = (email) =>
  typeof email === "string" && email.endsWith("@scribenote.com");

//make this a constant so it doesn't rerender
export const TAB_ARRAY = [
  {
    id: "savedDrafts",
    serverFilterKey: "draft",
    title: "Drafts",
    color: "bg-indigo-300 dark:bg-indigo-500",
    colorStyles: "border-indigo-300 dark:border-indigo-500",
    isExportWindow: false,
    description:
      "These are the notes you've started working on. Click on any note to keep editing it.",
    countKey: "numSavedDrafts",
  },
  {
    id: "nowProcessing",
    serverFilterKey: "processing",
    title: "Unsynced",
    color: "bg-yellow-300 dark:bg-yellow-500",
    colorStyles: "border-yellow-300 dark:border-yellow-500",
    isExportWindow: false,
    description:
      "Unsynced recordings need to be uploaded to our servers. Click the sync button to upload them. Processing recordings will automatically produce a note for review within a few minutes.",
    countKey: "numNowProcessing",
  },
  {
    id: "forReview",
    serverFilterKey: "review",
    title: "Available for Review",
    color: "bg-green-300 dark:bg-green-500",
    colorStyles: "border-green-300 dark:border-green-500",
    isExportWindow: false,
    description:
      "Once your recordings are processed into notes, they will appear here for you to review and edit.",
    countKey: "numForReview",
  },
  {
    id: "forExport",
    serverFilterKey: "export",
    title: "Ready to Export",
    color: "bg-blue-300 dark:bg-blue-500",
    colorStyles: "border-blue-300 dark:border-blue-500",
    isExportWindow: true,
    isAlreadyExported: false,
    description:
      "Exporting a note or clicking the checkmark icon will mark it as exported and move it to your exported notes tab.",
    countKey: "numForExport",
  },
  {
    id: "exportedItems",
    serverFilterKey: "exported",
    title: "Exported",
    color: "bg-purple-300 dark:bg-purple-500",
    colorStyles: "border-purple-300 dark:border-purple-500",
    isExportWindow: true,
    isAlreadyExported: true,
    description: "These are notes that have already been exported.",
    countKey: "numExportedItems",
  },
];

export const MCLOUD_COMMANDS = Object.freeze({
  FETCH_NOTE_DATA: "com.scribenote.data.notes.fetch",
  CATCH_NOTE_DATA: "com.scribenote.data.notes.catch",
  FETCH_USER_DATA: "com.scribenote.data.user.fetch",
  CATCH_USER_DATA: "com.scribenote.data.user.catch",
  FETCH_AUTH0_TOKEN: "com.scribenote.auth0.token.fetch",
  CATCH_AUTH_SIGNOUT: "com.mvp.auth.signout.catch",
  CATCH_AUTH0_TOKEN: "com.mvp.auth0.token.catch",
  SHOW_USER_MENU: "com.scribenote.layout.user_menu.show",
  HIDE_USER_MENU: "com.scribenote.layout.user_menu.hide",
});

export const WS_RECONNECT_WAIT = 30000;
